import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ICampaignExportOrderApi } from './campaign-export-dialog.interface';

@Injectable({
  providedIn: 'root',
})
export class CampaignExportOrdersService {
  private readonly http = inject(HttpClient);

  public getCampaignExportOrder(id: string): Observable<ICampaignExportOrderApi> {
    return this.http.get<ICampaignExportOrderApi>(`/campaign-export-orders/${id}`);
  }

  public createCampaignExportOrder(campaignExportId: string): Observable<ICampaignExportOrderApi> {
    return this.http.post<ICampaignExportOrderApi>('/campaign-export-orders', { campaignExportId });
  }

  public updateCampaignExportOrder(params: {
    id: string;
    order: number;
    campaignExportId: string;
    campaignId: string;
  }): Observable<ICampaignExportOrderApi> {
    return this.http.put<ICampaignExportOrderApi>(`/campaign-export-orders/${params.id}`, {
      campaignExportId: params.campaignExportId,
      campaignId: params.campaignId,
      order: params.order,
    });
  }
}
